import { useQuery } from '@tanstack/react-query'

import { conRespaldo } from '@/lib/campo/loUltimoQueSeSupo'
import { supabase } from '@/lib/supabase/cliente'
import { mensajeDeError } from '@/lib/supabase/errores'
import type { MiHerramienta } from '@/lib/supabase/tipos-bd'

/**
 * Qué herramienta lleva encima quien está mirando.
 *
 * Va por función y no leyendo la tabla, igual que `fn_mi_trabajo`: al operario
 * no se le abre `prestamos_herramienta` —vería los préstamos de todos— sino
 * que la función decide qué es suyo. Una tabla abierta con una política de
 * seguridad encima es más superficie que una función que devuelve lo justo.
 */
export function useMisHerramientas() {
  const consulta = useQuery({
    queryKey: ['mis-herramientas'],
    // Con respaldo: en la obra hace falta saber qué lleva encima.
    queryFn: () =>
      conRespaldo<MiHerramienta[]>('mis-herramientas', async () => {
        const { data, error } = await supabase.rpc('fn_mis_herramientas')

        if (error) throw new Error(mensajeDeError(error))
        return data ?? []
      }),
  })

  return {
    herramientas: consulta.data ?? [],
    cargando: consulta.isLoading,
    error: consulta.error?.message ?? null,
  }
}
